var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPress = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.734 18.214c-3.072 0-5.563-2.453-5.563-5.48 0-.506.07-.997.2-1.463",
  stroke: "#3A434A",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.773 1.859c2.755.982 2.755 11.507 0 12.489-.271.096-.565.03-.84-.055l-9.762-3.03V4.944l9.762-3.03c.275-.086.569-.152.84-.056Z",
  stroke: "#3A434A",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M1.16 8.103a3.158 3.158 0 0 1 3.158-3.158h1.853v6.316H4.318a3.158 3.158 0 0 1-3.157-3.158Z",
  stroke: "#3A434A",
  strokeWidth: 1.5
})));
export default SvgPress;